import CloseIcon from '@mui/icons-material/Clear'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import { gql } from 'graphql-tag'
import React from 'react'
import { Mutation } from 'react-apollo'
import Textarea from '../../common/textarea/Textarea'
import { i18n } from '../index'
import type { Assignment } from './data'
import css from './taskListCheckModal.css'
type Props = {
  open: boolean
  onClose: (...args: Array<any>) => any
  assignment: Assignment
}
type State = {
  comment: string
}
const UPDATE_ASSIGNMENT_STATUS = gql`
  mutation UpdateAssignmentStatus($id: ID!, $assignment: UpdateAssignmentType!) {
    updateAssignment(assignmentId: $id, assignment: $assignment) {
      id
      subject
      description
      assignee {
        id
        name
      }
      deadline
      status
      comment
    }
  }
`

class TaskListCheckModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      comment: props.assignment.comment || '',
    }
  }

  onSubmit = (mutation: (...args: Array<any>) => any) => {
    const { assignment } = this.props
    const { comment } = this.state
    mutation({
      variables: {
        id: assignment.id,
        assignment: {
          status: 'Done',
          comment: comment,
        },
      },
    })
  }
  onCompleted = () => {
    this.props.onClose()
  }

  render() {
    const { open, onClose, assignment } = this.props
    return (
      <Mutation
        mutation={UPDATE_ASSIGNMENT_STATUS}
        onCompleted={this.onCompleted}
        refetchQueries={() => ['Assignments']}
      >
        {(updateAssignmentStatus) => (
          <div className={css.component}>
            <Modal
              aria-labelledby='simple-modal-title'
              aria-describedby='simple-modal-description'
              open={open}
              onClose={onClose}
            >
              <div className={css.modal}>
                <div className={css.modalContent}>
                  <h4 className={css.title}>{i18n.t('taskList.checkModal.title')}</h4>
                  <p className={css.task}>{assignment.description}</p>
                  <Textarea
                    onChange={(e) =>
                      this.setState({
                        comment: e.target.value,
                      })
                    }
                    label={i18n.t('taskList.checkModal.commentLabel')}
                    value={this.state.comment}
                  />
                </div>
                <div className={css.actions}>
                  <Button onClick={() => onClose()}>{i18n.t('buttons.cancel')}</Button>
                  <Button variant='contained' color='primary' onClick={() => this.onSubmit(updateAssignmentStatus)}>
                    {i18n.t('taskList.checkModal.submitButtonText')}
                  </Button>
                </div>
                <a className={css.close} onClick={() => onClose()}>
                  <CloseIcon />
                </a>
              </div>
            </Modal>
          </div>
        )}
      </Mutation>
    )
  }
}

export default TaskListCheckModal
